export function storeList() {

  
  function csv_data(dataPath) {
    const request = new XMLHttpRequest(); // HTTPでファイルを読み込む
    request.addEventListener('load', (event) => { // ロードさせ実行
      const response = event.target.responseText; // 受け取ったテキストを返す
      csv_array(response); //csv_arrayの関数を実行
    });
    request.open('GET', dataPath, true); // csvのパスを指定
    request.send();
  }
  csv_data('./assets/csv/storeList.csv');

  function csv_array(data) {

    /*■■■■■■■■■■■■■■ 東北エリア ■■■■■■■■■■■■■■*/
    function tohoku(){
      const output_area = document.getElementById('areaTohoku');
      const area = [
        //{name:'北海道',nameEn:'hokkaido'},
        {name:'岩手県',nameEn:'iwate'},
        {name:'宮城県',nameEn:'miyagi'},
        //{name:'秋田県',nameEn:'akita'},
        {name:'山形県',nameEn:'yamagata'},
        {name:'福島県',nameEn:'fukushima'}
      ];
      let insertElement = '';
      insertElement += '<h3 class="storeList_area_ttl">東北</h3>';
      area.forEach(function(place) {
        const placeName = place.name;
        insertElement += '<section class="storeList_area_place ac_panel">';
        insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
        insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
        const dataString = data.split('\n'); // 改行で分割
        for (let i = 0; i < dataString.length; i++) { // あるだけループ
          const row = dataString[i].split(',');
          if (row.includes(placeName)) { // "件名"を含む配列のみ処理
            const dataArray = []; // 配列を用意
            dataArray.push(row);
            dataArray.forEach((element) => { // 配列の中身を表示
              insertElement += '<li class="storeList_item">';
              insertElement += '<dl>';
              insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += '<dl>';
              insertElement += '</li>';
            });
          }
        }
        insertElement += '</ul></div>';
        insertElement += '</section>';
        output_area.innerHTML = insertElement;
      });
    }
    tohoku();

    /*■■■■■■■■■■■■■■ 関東エリア ■■■■■■■■■■■■■■*/
    function kanto(){
      const output_area = document.getElementById('areaKanto');
      const area = [
        {name:'茨城県',nameEn:'ibaraki'},
        {name:'栃木県',nameEn:'tochigi'},
        {name:'群馬県',nameEn:'gunma'},
        {name:'埼玉県',nameEn:'saitama'},
        {name:'千葉県',nameEn:'chiba'},
        {name:'東京都',nameEn:'tokyo'},
        {name:'神奈川県',nameEn:'kanagawa'}
      ];
      let insertElement = '';
      insertElement += '<h3 class="storeList_area_ttl">関東</h3>';
      area.forEach(function(place) {
        const placeName = place.name;
        insertElement += '<section class="storeList_area_place ac_panel">';
        insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
        insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
        const dataString = data.split('\n'); // 改行で分割
        for (let i = 0; i < dataString.length; i++) { // あるだけループ
          const row = dataString[i].split(',');
          if (row.includes(placeName)) { // "件名"を含む配列のみ処理
            const dataArray = []; // 配列を用意
            dataArray.push(row);
            dataArray.forEach((element) => { // 配列の中身を表示
              insertElement += '<li class="storeList_item">';
              insertElement += '<dl>';
              insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += '<dl>';
              insertElement += '</li>';
            });
          }
        }
        insertElement += '</ul></div>';
        insertElement += '</section>';
        output_area.innerHTML = insertElement;
      });
    }
    kanto();

    /*■■■■■■■■■■■■■■ 中部エリア ■■■■■■■■■■■■■■*/
    function chubu(){
      const output_area = document.getElementById('areaChubu');
      const area = [
        {name:'新潟県',nameEn:'niigata'},
        {name:'富山県',nameEn:'toyama'},
        {name:'石川県',nameEn:'ishikawa'},
        {name:'福井県',nameEn:'fukui'},
        {name:'山梨県',nameEn:'yamanashi'},
        {name:'長野県',nameEn:'nagano'},
        {name:'静岡県',nameEn:'shizuoka'},
        //{name:'岐阜県',nameEn:'gifu'},
        {name:'愛知県',nameEn:'aichi'}
      ];
      let insertElement = '';
      insertElement += '<h3 class="storeList_area_ttl">中部</h3>';
      area.forEach(function(place) {
        const placeName = place.name;
        insertElement += '<section class="storeList_area_place ac_panel">';
        insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
        insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
        const dataString = data.split('\n'); // 改行で分割
        for (let i = 0; i < dataString.length; i++) { // あるだけループ
          const row = dataString[i].split(',');
          if (row.includes(placeName)) { // "件名"を含む配列のみ処理
            const dataArray = []; // 配列を用意
            dataArray.push(row);
            dataArray.forEach((element) => { // 配列の中身を表示
              insertElement += '<li class="storeList_item">';
              insertElement += '<dl>';
              insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += '<dl>';
              insertElement += '</li>';
            });
          }
        }
        insertElement += '</ul></div>';
        insertElement += '</section>';
        output_area.innerHTML = insertElement;
      });
    }
    chubu();

    /*■■■■■■■■■■■■■■ 近畿エリア ■■■■■■■■■■■■■■*/
    function kinki(){
      const output_area = document.getElementById('areaKinki');
      const area = [
        {name:'三重県',nameEn:'mie'},
        {name:'滋賀県',nameEn:'shiga'},
        {name:'京都府',nameEn:'kyoto'},
        {name:'大阪府',nameEn:'osaka'},
        {name:'兵庫県',nameEn:'hyogo'},
        {name:'奈良県',nameEn:'nara'},
        {name:'和歌山県',nameEn:'wakayama'}
      ];
      let insertElement = '';
      insertElement += '<h3 class="storeList_area_ttl">近畿</h3>';
      area.forEach(function(place) {
        const placeName = place.name;
        insertElement += '<section class="storeList_area_place ac_panel">';
        insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
        insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
        const dataString = data.split('\n'); // 改行で分割
        for (let i = 0; i < dataString.length; i++) { // あるだけループ
          const row = dataString[i].split(',');
          if (row.includes(placeName)) { // "件名"を含む配列のみ処理
            const dataArray = []; // 配列を用意
            dataArray.push(row);
            dataArray.forEach((element) => { // 配列の中身を表示
              insertElement += '<li class="storeList_item">';
              insertElement += '<dl>';
              insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += '<dl>';
              insertElement += '</li>';
            });
          }
        }
        insertElement += '</ul></div>';
        insertElement += '</section>';
        output_area.innerHTML = insertElement;
      });
    }
    kinki();

    /*■■■■■■■■■■■■■■ 中国・四国エリア ■■■■■■■■■■■■■■*/
    function chugoku_shikoku(){
      const output_area = document.getElementById('areaChugoku_Shikoku');
      const area = [
        {name:'鳥取県',nameEn:'tottori'},
        //{name:'島根県',nameEn:'shimane'},
        {name:'岡山県',nameEn:'okayama'}
        //{name:'広島県',nameEn:'hiroshima'},
        //{name:'山口県',nameEn:'yamaguchi'},
        //{name:'徳島県',nameEn:'tokushima'},
        //{name:'香川県',nameEn:'kagawa'},
        //{name:'愛媛県',nameEn:'ehime'},
        //{name:'高知県',nameEn:'kochi'}
      ];
      let insertElement = '';
      insertElement += '<h3 class="storeList_area_ttl">四国・中国</h3>';
      area.forEach(function(place) {
        const placeName = place.name;
        insertElement += '<section class="storeList_area_place ac_panel">';
        insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
        insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
        const dataString = data.split('\n'); // 改行で分割
        for (let i = 0; i < dataString.length; i++) { // あるだけループ
          const row = dataString[i].split(',');
          if (row.includes(placeName)) { // "件名"を含む配列のみ処理
            const dataArray = []; // 配列を用意
            dataArray.push(row);
            dataArray.forEach((element) => { // 配列の中身を表示
              insertElement += '<li class="storeList_item">';
              insertElement += '<dl>';
              insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
              insertElement += '<dl>';
              insertElement += '</li>';
            });
          }
        }
        insertElement += '</ul></div>';
        insertElement += '</section>';
        output_area.innerHTML = insertElement;
      });
    }
    chugoku_shikoku();


    /*■■■■■■■■■■■■■■ 九州・沖縄エリア ■■■■■■■■■■■■■■*/
    // function kyushu_okinawa(){
    //   const output_area = document.getElementById('areaKyushu_Okinawa');
    //   const area = [
    //     {name:'福岡県',nameEn:'fukuoka'},
    //     {name:'佐賀県',nameEn:'saga'},
    //     {name:'長崎県',nameEn:'nagasaki'},
    //     {name:'熊本県',nameEn:'kumamoto'},
    //     {name:'福岡県',nameEn:'fukuoka'},
    //     {name:'大分県',nameEn:'oita'},
    //     {name:'宮崎県',nameEn:'miyazaki'},
    //     {name:'福岡県',nameEn:'fukuoka'},
    //     {name:'鹿児島県',nameEn:'kagoshima'},
    //     {name:'沖縄県',nameEn:'okinawa'}
    //   ];
    //   let insertElement = '';
    //   insertElement += '<h3 class="storeList_area_ttl">九州・沖縄</h3>';
    //   area.forEach(function(place) {
    //     const placeName = place.name;
    //     insertElement += '<section class="storeList_area_place ac_panel">';
    //     insertElement += '<div class="storeList_area_place_head ac_heading"><h4 class="storeList_area_place_head_ttl">' + placeName + '</h4><span></span></div>';
    //     insertElement += '<div class="storeList_area_place_body ac_content"><ul>';
    //     const dataString = data.split('\n'); // 改行で分割
    //     for (let i = 0; i < dataString.length; i++) { // あるだけループ
    //       const row = dataString[i].split(',');
    //       if (row.includes(placeName)) { // "件名"を含む配列のみ処理
    //         const dataArray = []; // 配列を用意
    //         dataArray.push(row);
    //         dataArray.forEach((element) => { // 配列の中身を表示
    //           insertElement += '<li class="storeList_item">';
    //           insertElement += '<dl>';
    //           insertElement += `<dt>${element[1]}店</dt>`; // 2番目をpタグ、6番目をspanタグで出力
    //           insertElement += `<dd>${element[4]}${element[5]}${element[6]}</dd>`; // 2番目をpタグ、6番目をspanタグで出力
    //           insertElement += '<dl>';
    //           insertElement += '</li>';
    //         });
    //       }
    //     }
    //     insertElement += '</ul></div>';
    //     insertElement += '</section>';
    //     output_area.innerHTML = insertElement;
    //   });
    // }
    // kyushu_okinawa();

  }
  // window.onload = function() {
  //   const elements = document.querySelectorAll('.storeList_area_place_body');
  //   elements.forEach(function(element) {
  //       element.classList.add('is-ready');
  //   });
  // };
}
